/**
 * Variante de pantalla dedicada exclusivamente a cambiar o elegir membresía.
 *
 * Reutiliza la misma fuente de planes que la landing y orienta el copy al
 * cambio de membresía dentro del flujo de suscripción.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // Para verificar si el usuario está autenticado
import membershipPlans from "./membershipPlanData";
import "./MembershipPlans.scss";

const Membresias = () => {
  const { currentUser } = useAuth(); // Obtener estado de autenticación
  const navigate = useNavigate();

  const handleSelectPlan = (plan) => {
    if (!currentUser) {
      // Si el usuario no está autenticado, redirigir al registro o login con el plan seleccionado
      navigate("/register", { state: { selectedPlan: plan } });
    } else {
      // Si el usuario está autenticado pero no tiene membresía activa, redirigir al pago
      // Aquí necesitarías verificar si tiene una membresía activa (puedes agregar esta lógica en el backend o al contexto)
      navigate("/payment", { state: { selectedPlan: plan } });
    }
  };

  return (
    <section id="membresias" className="membership-plans membership-plans--switcher">
      <div className="contenedor-membresias">
        <div className="membership-topbar">
          <button type="button" onClick={() => navigate(-1)}>
            Volver
          </button>
          <button
            type="button"
            onClick={() => navigate(currentUser ? "/dashboard" : "/login")}
          >
            {currentUser ? "Ir al dashboard" : "Ya tengo cuenta"}
          </button>
        </div>

        <div className="membership-heading">
          <span>Cambia tu elección</span>
          <h2>Elige la membresía que mejor acompaña tu proceso</h2>
          <p>
            Puedes ajustar el plan antes de pagar. Al elegir una opción te
            llevaremos de nuevo al paso de suscripción con el precio correcto.
          </p>
        </div>

        <div className="membership-flow-note">
          <strong>Estás en el selector de membresías.</strong>
          <span>
            Revisa beneficios, cambia de plan si lo necesitas y continúa sin
            perder el avance de tu registro.
          </span>
        </div>

        <div className="plans">
          {membershipPlans.map((plan) => (
            <article
              className={`plan ${plan.featured ? "plan--featured" : ""}`}
              key={plan.key}
            >
              <div className="plan-header">
                <span className="plan-badge">{plan.badge}</span>
                <h3>{plan.name}</h3>
                <p>{plan.summary}</p>
              </div>
              <div className="plan-price">
                <strong>{plan.formattedPrice}</strong>
                <span>{plan.period}</span>
              </div>
              <button
                className="btn-accion"
                onClick={() => handleSelectPlan(plan.key)}
              >
                Elegir {plan.name}
              </button>
              <div className="descr-plan">
                {plan.sections.map((section, sectionIndex) => (
                  <div className="plan-section" key={section.title}>
                    {sectionIndex > 0 && <div className="divider"></div>}
                    <h4>{section.title}</h4>
                    <ul>
                      {section.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Membresias;
